import axios from "axios";
import {
  NEA_WORKFLOW
} from "../constants/NeaWorkflow";

import {
  setNeaWorkflow
} from "../service/JweSession";
const { REACT_APP_FILE_UPLOAD_API_URL, REACT_APP_REPLACE_FILE_UPLOAD_API_URL, REACT_APP_MULTI_FILE_UPLOAD_API_URL,
        REACT_APP_CREATE_RECAP_DEMANDE_API_URL, REACT_APP_UPDATE_RECAP_DEMANDE_API_URL, REACT_APP_CREATE_PDF_DEPASS_PLAFOND_API_URL,REACT_APP_CREATE_RECAP_DEMANDE_GEN_API_URL} = process.env;


export class FileService {
  uploadFile(files) {
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    let formDat = new FormData();
    files.forEach((file) => {
      formDat.append("files", file);
    }); 
    return axios.post(REACT_APP_FILE_UPLOAD_API_URL,formDat,{
      headers: header,
      withCredentials: 'omit'
    });
  }

  createRecaputilatifDemande(infosDemandeClapDto) {
    setNeaWorkflow(NEA_WORKFLOW.RECAP_CREATE);
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    return axios.post(REACT_APP_CREATE_RECAP_DEMANDE_API_URL, infosDemandeClapDto,{
      headers: header,
      withCredentials: 'omit'
    });
  }

  updateRecaputilatifDemande(infosDemandeClapDto, demandeId) {
    setNeaWorkflow(NEA_WORKFLOW.RECAP_CREATE);
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    let formDat = new FormData();
    formDat.append("infosDemandeClapDto", JSON.stringify(infosDemandeClapDto));
    formDat.append("demandeId",demandeId);
    return axios.post(REACT_APP_UPDATE_RECAP_DEMANDE_API_URL, formDat,{
      headers: header,
      withCredentials: 'omit'
    });
  }

  uploadMultiFile(fileMap) {
    setNeaWorkflow(NEA_WORKFLOW.JUSTIFICATIF_UPLOAD);
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    let formDat = new FormData();
    Object.entries(fileMap).forEach(([key, value]) => {
      delete value.file.category;
      formDat.append("categories", value.category[0]);
      formDat.append("files", value.file)
    });
    return axios.post(REACT_APP_MULTI_FILE_UPLOAD_API_URL, formDat,{
      headers: header,
      withCredentials: 'omit'
    });
  }

  uploadEditedFiles(filesRaw,recordIds,categories) {
    setNeaWorkflow(NEA_WORKFLOW.JUSTIFICATIF_EDIT);
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    let formDat = new FormData();

    Object.entries(filesRaw).forEach(([key, value]) => {
          delete value.file.category;
          formDat.append("categories", value.category[0]);
          formDat.append("files", value.file)
    });
    formDat.append("recordIds",recordIds);

    return axios.post(REACT_APP_REPLACE_FILE_UPLOAD_API_URL,formDat,{
      headers: header,
      withCredentials: 'omit'
    });
  }

  createPdfDepassementPlafond(info) {
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    return axios.post(REACT_APP_CREATE_PDF_DEPASS_PLAFOND_API_URL, info,{
      headers: header,
      withCredentials: 'omit'
    });
  }


  createRecapDemande(infosDemandeClapDto) {
    setNeaWorkflow(NEA_WORKFLOW.RECAP_CREATE);
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'true',
    };
    return axios.post(REACT_APP_CREATE_RECAP_DEMANDE_GEN_API_URL, infosDemandeClapDto,{
      headers: header,
      withCredentials: 'omit'
    });
  }

}
